jQuery(document).ready(function($){
    function wm_init_slider() {
        let slider_opts = {
            dots: true,
            speed: 300,
            infinite: false,
            autoplay: false,
            fade: false,
            autoplaySpeed: 5000,
            cssEase: 'ease-out',
            arrows: false,
            prevArrow: '<button type="button button--outline" class="slick-prev"><i class="icon-chevron-left"></i></button>',
            nextArrow: '<button type="button button--outline" class="slick-next"><i class="icon-chevron-right"></i></button>',
        };

        let slider_style = $(this).data('slider-style') || 'medium';

        if (slider_style === 'medium') {
            slider_opts.slidesToShow = 3;

            slider_opts.responsive = [
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ];
        } else if (slider_style === 'variable') {
            slider_opts.variableWidth = true;
            slider_opts.swipeToSlide = true;
            slider_opts.outerEdgeLimit = true;
            slider_opts.responsive = false;
            slider_opts.dots = false;
        } else if (slider_style === 'single') {
            slider_opts.slidesToShow = 1;
            slider_opts.slidesToScroll = 1;
            slider_opts.responsive = false;
        }

        let $slider_parent = $(this).parents('[data-slider-parent]');

        if ($slider_parent.length) {
            let $arrows = $slider_parent.find('[data-slider-arrows]');

            if ($arrows.length) {
                slider_opts.appendArrows = $arrows;
            }

            let $dots = $slider_parent.find('[data-slider-dots]');

            if ($dots.length) {
                slider_opts.appendDots = $dots;
            }
        }

        $(this).slick(slider_opts);

    }

    if ($('[data-slider]').length) {
        $('[data-slider]').each(wm_init_slider);
    }

});
